import { Link, useMatch, useResolvedPath } from "react-router-dom";

export default function Navbar(path) {
  return (
    <nav id="menu">
      <ul>
        <CustomLink id="home" to="/">Home</CustomLink>
        <CustomLink id="addresses" to="/addresses">Addresses</CustomLink>
        <CustomLink id="location" to="/location">Location</CustomLink>
        <CustomLink id="lodging" to="/lodging">Lodging</CustomLink>
        <CustomLink id="committees" to="/committees">Committees</CustomLink>
        <CustomLink id="mailings" to="/schedule">Schedule</CustomLink>
        <CustomLink id="photos" to="/photos">Photos</CustomLink>
      </ul>
    </nav>
  );
}

function CustomLink({id, to, children, ...props}) {
  const resolvedPath = useResolvedPath(to);  // Converts a relative path to an absolute path for comparison
  const isActive = useMatch({ path: resolvedPath.pathname, end: true});  // end: true = match whole path against current page url
  return (
    <li id={id} className={(isActive)?"active":""}>
      <Link to={to} {...props}>{children}</Link>
    </li>
  );
}